module.exports = __webpack_public_path__ + "assets/coco_dark.dc7269c3.svg";